import { system, LookupStorage } from "portalframework";
import * as ko from "knockout";
import * as _ from "lodash";
import * as $ from "jquery";
import * as entitiesE from "entitiesE";
import * as toastr from "toastr";
import {
  extended_request,
  product,
  attachment_wrapper,
  searchResult,
  RequestIncidentSearchCriteria,
  incident_subscriber,
} from "organized";
import labels from "app/labels";
import { BaseService } from "../_common/_baseService";
import { request_dto } from "organized";
import { AttachmentResultDTO, downloadAttachmentFromBase64 } from "../attachment.service";
import { portalHttpService } from "../_common/httpService";
import { httpErrorHandler } from "../_common/httpErrorHandler";
let Lookups = LookupStorage.lookupStorage;

class IncidentRequestService extends BaseService {
  constructor() {
    super("IncidentRequest");
  }

  public getIncidentRequestScreenData = async (): Promise<void> => {
    let requiredLookups = [
      "PLACEPERSONS",
      "C_ESCALATION_STATUS",
      "C_IMPACT",
      "URGENCY",
      "C_PHENOMENON_CLASS",
      "C_PHENOMENOM_CODE",
      "MODEL_TYPE",
      "C_NETWORK_INTERFACE",
      "C_CONNECTION",
      "C_OPERATING_SYSTEM",
      "REQ_CLASS",
      "REQ_GROUP",
      "REQ_STATUS",
      "C_PRIOIMPACTURGENCY",
    ];
    let lookupsToFetch = _.difference(requiredLookups, Lookups.lookupNames());
    let payload = ko.toJSON({ requiredLookups: lookupsToFetch });
    const data = await portalHttpService.post<any>(`${this.baseApiUrl()}/IncidentRequestScreenData`, payload);
    this.setLookupData(lookupsToFetch, data.results);
  };

  public getIncidentRequestById = async (request_id: string) => {
    const requestReceived = await portalHttpService.get(`${this.baseApiUrl()}/getIncidentRequestById/${request_id}`);
    return new extended_request(requestReceived);
  };

  public changeStatus = async (request_id: string, to_status: string, reason: string): Promise<void> => {
    await portalHttpService.post(
      `${this.baseApiUrl()}/changeStatus`,
      ko.toJSON({ request_id: request_id, to_status: to_status, reason: reason }),
    );
  };

  public searchHardwareModels = async (criteria: string): Promise<entitiesE.SearchResult> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/SearchHardwareModels",
      ko.toJSON({ model_id: criteria, Rows: 15, Page: 0 }),
    );
    let models = new entitiesE.SearchResult({ data: data.result.models, count: data.count });
    return models;
  };

  public validateSerial = async (serial: string): Promise<KnockoutObservable<product>> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/ValidateSerial",
      ko.toJSON({ serial: serial }),
    );
    let product1 = entitiesE.loadRelation(data.product, product, "product", "single");
    return product1;
  };

  public getSoftwareModels = async (model_type: string): Promise<string[]> => {
    let currentSoftwareModels = Lookups.get(`SoftwareModels-${model_type}`);
    if (currentSoftwareModels.length > 0) {
      return currentSoftwareModels;
    } else {
      const data = await portalHttpService.post<any>(
        system.apiURL() + "api/IncidentRequest/getSoftwareModels",
        ko.toJSON({ model_type: model_type }),
      );
      Lookups.add(new LookupStorage.Lookup(`SoftwareModels-${model_type}`, data, ""));
      return data;
    }
  };

  private setLookupData = (lookupsToFetch: string[], results: any) => {
    _.each(lookupsToFetch, (lookupName) => {
      let list = results[lookupName];
      if (list) {
        if (lookupName == "PLACEPERSONS" && typeof list["person"] !== "undefined") {
          if (!Array.isArray(list.person)) {
            list["placepersons"] = [list["person"]];
          } else {
            list["placepersons"] = list["person"];
          }
          delete list["person"];
          if (list.placepersons.length > 0) {
            _.remove(list.placepersons, function (currentObject) {
              return currentObject["user_def9"] === "DENY";
            });
            _.each(list.placepersons, (p) => {
              p.description = p.first_name + " " + p.last_name;
              p.placepersons = p.person_id;
            });
          }
        }
        Lookups.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
  };

  public searchRequests = async (
    criteria: RequestIncidentSearchCriteria,
  ): Promise<searchResult<extended_request[]>> => {
    const data: searchResult<any[]> = await portalHttpService.post<any>(
      `${this.baseApiUrl()}/SearchRequests`,
      criteria.toJSON(),
    );
    let requests: extended_request[] = data?.result?.map((req) => new extended_request(req)) || [];
    return new searchResult<extended_request[]>({
      result: requests,
      count: data.count,
    });
  };

  public getRequestsCount = async (criteria: RequestIncidentSearchCriteria): Promise<number> => {
    const data: number = await portalHttpService.post<any>(`${this.baseApiUrl()}/GetRequestsCount`, criteria.toJSON());
    return data;
  };

  public saveRequest = (req: request_dto): Promise<{}> => {
    var data = ko.toJS(req);
    let attachments = data.request_attachment;
    delete data.request_attachment;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: system.apiURL() + "api/IncidentRequest/save",
        type: "POST",
        data: JSON.stringify(data),
        beforeSend: function (xhr: any) {
          xhr.withCredentials = true;
        },
        xhrFields: {
          withCredentials: true,
        },
        crossDomain: true,
      })
        .done((data) => {
          let savedreq = new request_dto(data.results.request);
          if (attachments.length > 0) {
            this.SaveAttachments(savedreq, attachments).then(function () {
              toastr.success("Request saved");
              resolve(savedreq);
            });
          } else {
            toastr.success("Request saved");
            resolve(savedreq);
          }
        })
        .fail(function (error) {
          console.error(error);
          reject(httpErrorHandler.processError(error));
        });
    });
  };

  public subscribe = async (request_id: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/subscribe",
      ko.toJSON({ request_id: request_id }),
    );
  };

  public getSubscribers = async (request_id: string) => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetSubscribersForRequestId/`);
    myUrlWithParams.searchParams.append("request_id", request_id);

    const data: any[] = await portalHttpService.get(myUrlWithParams.href);

    return data.map((p) => new incident_subscriber(p));
  };

  updateSubscribers = async (
    request_id: string,
    toSubmit: { person_id: string; is_subscribed: boolean }[],
  ): Promise<boolean> => {
    const data = ko.toJSON({
      request_id: request_id,
      persons: toSubmit,
    });
    return await portalHttpService.post<boolean>(`${this.baseApiUrl()}/UpdateSubscribers`, data);
  };

  public unsubscribe = async (request_id: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/unsubscribe",
      ko.toJSON({ request_id: request_id }),
    );
  };

  public updatePriority = async (request_id: string, priority: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/updatePriority",
      ko.toJSON({ request_id: request_id, priority: priority }),
    );
  };

  public addNote = async (
    request_id: string,
    note: string,
    type: string,
    key: string,
  ): Promise<entitiesE.screenNote[]> => {
    const data = ko.toJSON({ request_id: request_id, note: note, type: type, key: key });

    const result = await portalHttpService.post<any>(system.apiURL() + "api/IncidentRequest/addNote", data);
    let notesUpdate = entitiesE.loadRelation(result, entitiesE.screenNote, "screenNote", "array");
    toastr.success("Note saved");
    return notesUpdate();
  };

  public parseUSBLogFile = (attachments: attachment_wrapper[]): Promise<any> => {
    return new Promise((resolve, reject) => {
      let progress = system.spin();
      var nrOfAttachments = attachments.length;
      var cnt = 0;
      var finalData = [];
      ko.utils.arrayForEach(attachments, (attachmentToSave: any) => {
        attachmentToSave = ko.toJS(attachmentToSave);
        if (!attachmentToSave.attachment_id) {
          var formData = new FormData();
          formData.append("imageData", dataURLtoBlob(attachmentToSave.attachment.file.filedata));
          formData.append("attachment_name", attachmentToSave.attachment.attachment_name);
          formData.append("attachment_type", attachmentToSave.attachment.attachment_type);
          formData.append("file_type", attachmentToSave.attachment.file_type);
          formData.append("attachment_description", attachmentToSave.attachment.attachment_description);
          $.ajax({
            type: "POST",
            url: system.apiURL() + "api/IncidentRequest/ParseUSBFile",
            data: formData,
            contentType: false,
            processData: false,
            success: function (data) {
              finalData.push({ file: data.file, data: data });
              cnt += 1;
              if (cnt == nrOfAttachments) {
                resolve(finalData);
                system.clearspin(progress);
              }
            },
            error: function (data) {
              system.clearspin(progress);
              console.error(data);
              toastr.error("There was an error uploading your file! The description might be too long.");
            },
          });
        }
      });
    });
  };

  private SaveAttachments = (savedreq, attachments): Promise<{}> => {
    return new Promise((resolve, reject) => {
      var nrOfAttachments = attachments.length;
      var cnt = 0;
      ko.utils.arrayForEach(attachments, (attachmentToSave: any) => {
        if (!attachmentToSave.attachment_id) {
          this.SaveAttachment(savedreq.request_id(), attachmentToSave).then((savedAttachment: any) => {
            cnt += 1;
            savedreq.request_attachment.push(new attachment_wrapper(savedAttachment.request_attachment));
            if (cnt == nrOfAttachments) {
              resolve({});
            }
          });
        }
      });
    });
  };
  public SaveAttachment = (request_id, attachment): Promise<{}> => {
    return new Promise((resolve, reject) => {
      var formData = new FormData();
      formData.append("imageData", dataURLtoBlob(attachment.attachment.file.filedata));
      formData.append("request_id", request_id);
      formData.append("attachment_name", attachment.attachment.attachment_name);
      formData.append("attachment_type", attachment.attachment.attachment_type);
      formData.append("file_type", attachment.attachment.file_type);
      formData.append("attachment_description", attachment.attachment.attachment_description);
      formData.append("task_or_request", "request");
      let progress = system.spin();
      $.ajax({
        type: "POST",
        url: system.apiURL() + "api/Attachment/Upload",
        data: formData,
        contentType: false,
        processData: false,
        success: function (data) {
          system.clearspin(progress);
          resolve(data);
        },
        error: function (data) {
          system.clearspin(progress);
          console.error(data);
          toastr.error("There was an error uploading your file! The description might be too long.");
        },
      });
    });
  };

  public exportFile = async (
    criteria: RequestIncidentSearchCriteria,
    headers: { label: string; css: KnockoutComputed<string>; sortMe: () => void }[],
    offset: any,
  ): Promise<void> => {
    criteria.isExport(true);
    const labelsResult = headers.map((header) => labels.descr(header.label)).join(",");
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/ExportIncidentRequestFile/`);
    myUrlWithParams.searchParams.append("criteria", criteria.toJSON());
    myUrlWithParams.searchParams.append("labelsString", labelsResult);
    myUrlWithParams.searchParams.append("timeZone", `${offset}`);

    const fileResult = await portalHttpService.get<AttachmentResultDTO>(myUrlWithParams.href);
    downloadAttachmentFromBase64(fileResult);
  };

  public creatRequestAttachment = (request_id, attachment) => {
    var request_attachment_data = {
      request_id: request_id,
      attachment: {
        file: attachment.file,
        attachment_name: attachment.name,
        attachment_type: attachment.attachment_type,
        attachment_description: attachment.description,
        file_type: attachment.contentType,
      },
    };

    return new attachment_wrapper(request_attachment_data);
  };

  public changeDeadline = async (request_id: string, reason: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/changeDeadline",
      ko.toJSON({ request_id: request_id, reason: reason }),
    );
  };

  submitRequestToKyocera = async (request_id: string) => {
    await portalHttpService.get<any>(`${this.baseApiUrl()}/SubmitRequestToKyocera/${request_id}`);
  };

  closeIncidentRequest = async (request_id: string, comment: string) => {
    const data = ko.toJSON({
      request_id,
      comment,
    });
    await portalHttpService.post<any>(`${this.baseApiUrl()}/CloseIncidentRequest`, data);
  };
  dropIncidentRequest = async (request_id: string, comment: string) => {
    const data = ko.toJSON({
      request_id,
      comment,
    });
    await portalHttpService.post<any>(`${this.baseApiUrl()}/DropIncidentRequest`, data);
  };

  searchDiagnosticCode = async (value: string) => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetDiagnosticCodes/`);
    myUrlWithParams.searchParams.append("searchValue", value);

    return await portalHttpService.get<any[]>(myUrlWithParams.href);
  };

  searchFailureCode = async (value: string) => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetFailureCodes/`);
    myUrlWithParams.searchParams.append("searchValue", value);

    return await portalHttpService.get<any[]>(myUrlWithParams.href);
  };
}

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
export const incidentRequestService = new IncidentRequestService();
